var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 16.001,
    viewBox: "0 0 16.001 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-13272-10560a8.009,8.009,0,0,1-8-8,8.007,8.007,0,0,1,8-8,8.01,8.01,0,0,1,8,8A8.011,8.011,0,0,1-13272-10560Zm.667-8v4h1.666a1,1,0,0,0,1-1v-3Zm-4,0v3a1,1,0,0,0,1,1h1.67v-4Zm-.333-2.333a.333.333,0,0,0-.333.333v1a.334.334,0,0,0,.333.334h7.336a.334.334,0,0,0,.333-.334v-1a.333.333,0,0,0-.333-.333h-.8a1.244,1.244,0,0,0,.133-.513,1.2,1.2,0,0,0-1.2-1.153h-.025a2.069,2.069,0,0,0-1.78,1.17,2.048,2.048,0,0,0-1.766-1.17h-.037a1.193,1.193,0,0,0-1.2,1.153v.022a1.188,1.188,0,0,0,.126.49Zm5.476,0h-1.316a1.549,1.549,0,0,1,1.3-1h.014a.53.53,0,0,1,.529.487A.525.525,0,0,1-13270.192-10570.331Zm-2.3,0h-1.307a.541.541,0,0,1-.537-.5.539.539,0,0,1,.533-.5h.007a1.55,1.55,0,0,1,1.3,1Z",
    transform: "translate(13280 10576)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/Icon_Gift.527ecda22b234a7c87b0f4c5e8128e1c.svg";
export { ForwardRef as ReactComponent };